export default __webpack_public_path__ + "static/media/wallpaperflare.com_wallpaper2.d5384605.png";